import { useTranslation } from "react-i18next";

const MAX_LISTED_NAMES = 8;

/** Tooltip body for a hub selection: the first names, then how many are left unnamed. */
export function OpportunityHubNameList({
  names,
  total = names.length,
}: {
  names: readonly string[];
  /** Selected count. Rows that have not loaded yet have no name, so this can exceed `names`. */
  total?: number;
}) {
  const { t } = useTranslation();
  const listed = names.slice(0, MAX_LISTED_NAMES);
  const remaining = total - listed.length;

  return (
    <ul className="flex max-w-[20rem] flex-col gap-0.5" data-testid="opportunity-hub-selection-names">
      {listed.map((name, index) => (
        <li key={`${name}-${index}`} className="truncate">
          {name}
        </li>
      ))}
      {remaining > 0 ? (
        <li className="opacity-70">
          {t("personaOpportunities.hub.selection.moreNames", {
            count: remaining,
            defaultValue_one: "+{{count}} more",
            defaultValue_other: "+{{count}} more",
          })}
        </li>
      ) : null}
    </ul>
  );
}
